<!--  -->
<template>
  <div>
    <div class="page">
      <p style="text-align:left;">
        参观时间：{{ this.date }}&nbsp;&nbsp;{{ this.sence.type }}({{
          this.sence.title
        }})
      </p>
      <p style="text-align:left;">
        个人信息
      </p>
      <div class="info">
        <div class="info_header">
          <a-row :gutter="16">
            <a-col :span="2"> <p>序号</p> </a-col>
            <a-col :span="5"> <p>门票种类</p> </a-col>
            <a-col :span="5"> <p>姓名</p> </a-col>
            <a-col :span="5"> <p>证件类型</p> </a-col>
            <a-col :span="5"> <p>证件号码</p> </a-col>
            <a-col :span="2"> <p>操作</p> </a-col>
          </a-row>
        </div>
        <div class="info_action">
          <div v-for="(item, index) in info" :key="index">
            <a-row :gutter="16" class="info_item">
              <a-col :span="2">
                <a-button shape="circle">{{ index + 1 }}</a-button>
              </a-col>
              <a-col :span="5">
                <a-select
                  style="width:100%"
                  v-model="info[index].shape"
                  placeholder="请选择票种"
                  @change="selectPrice(index)"
                >
                  <a-select-option
                    v-for="(item1, index1) in shape"
                    :key="index1"
                    :value="item1.id"
                  >
                    {{ item1.title }}&nbsp;&nbsp;￥{{ item1.price }}
                  </a-select-option>
                </a-select>
              </a-col>
              <a-col :span="5">
                <a-input
                  v-model="info[index].name"
                  placeholder="请输入姓名"
                  style="width:100%"
                />
              </a-col>
              <a-col :span="5">
                <a-select default-value="身份证" style="width:100%">
                  <a-select-option value="身份证">
                    身份证
                  </a-select-option>
                </a-select>
              </a-col>
              <a-col :span="5">
                <a-input
                  v-model="info[index].identityNo"
                  placeholder="请输入证件号码"
                  style="width:100%"
                />
              </a-col>
              <a-col :span="2">
                <a-button type="link" @click="del(index)">
                  删除
                </a-button>
              </a-col>
            </a-row>
          </div>
          <div class="info_header" style="margin-top:50px">
            <a-row :gutter="16">
              <a-col :span="2"> <p style="border:0">手机号</p> </a-col>
              <a-col :span="5">
                <a-input
                  v-model="tel"
                  placeholder="请输入11位手机号"
                  style="width:100%"
                ></a-input>
              </a-col>
            </a-row>
          </div>
          <p class="price">
            总计: <span class="num">￥{{ totalPirce }}</span>
          </p>
          <div style="padding-top:30px">
            <a-button @click="leftStep" style="margin-right:15px"
              >上一步</a-button
            >
            <a-button
              @click="add"
              :disabled="info.length >= 5"
              style="margin-right:15px"
              >添加参观者</a-button
            >
            <a-button @click="nextStep" type="primary" :loading="loading"
              >确定预约</a-button
            >
          </div>
        </div>
      </div>
    </div>
    <TicketPay ref="ticketing-payment" @succeed="handlePaymentSucceed" />
  </div>
</template>

<script>
import { createOrder, payOrder } from "@/api/api-ticket";
import TicketPay from "./TicketPay.vue";
export default {
  components: {
    TicketPay
  },
  data() {
    return {
      info: [
        {
          name: "",
          identityNo: "",
          shape: "",
          price: 0
        }
      ],
      tel: "",
      loading: false
    };
  },
  computed: {
    date() {
      return sessionStorage.getItem("date");
    },
    // 场次信息
    sence() {
      return JSON.parse(sessionStorage.getItem("sence"));
    },
    tid() {
      return sessionStorage.getItem("tid");
    },
    shape() {
      return JSON.parse(sessionStorage.getItem("shape"));
    },
    totalPirce() {
      let price = this.info.reduce(
        (totalPrice, item) => totalPrice + parseFloat(item.price),
        0
      );
      return price;
    }
  },
  watch: {},
  methods: {
    add() {
      this.info.push({ name: "", identityNo: "", shape: "", price: 0 });
    },
    del(index) {
      this.info.splice(index, 1);
    },
    // 验证身份证
    IsCard(str) {
      var reg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/;
      return reg.test(str);
    },
    check() {
      return new Promise((resolve, reject) => {
        if (!/^[1]([3-9])[0-9]{9}$/.test(this.tel)) {
          reject(`您的手机号填写有误`);
        }
        this.info.forEach((item, index) => {
          if (item.name && item.identityNo && item.shape) {
            if (this.IsCard(item.identityNo)) {
              resolve();
            } else {
              reject(`第${index + 1}行证件号码格式有误`);
            }
          } else {
            reject(`第${index + 1}行信息填写不完整`);
          }
        });
      });
    },
    handlePaymentSucceed() {
      this.$emit("orderSuccess");
    },
    // 支付订单 有两种方式  1.免费预约15  2.不免费，需要扫码付款
    payOrderByOrderId(orderid) {
      payOrder({
        orderid: orderid,
        paychannel: this.totalPirce > 0 ? "89" : "15"
      }).then(res => {
        this.loading = false;
        if (this.totalPirce > 0) {
          if (res) {
            this.$refs["ticketing-payment"].toggle({
              orderId: orderid,
              qrcode: res.url
            });
          }
        } else {
          this.$message.success("预约成功");
          setTimeout(() => {
            this.$emit("orderSuccess");
          }, 1000);
        }
      });
    },
    // 创建订单
    createOrderDe() {
      let that = this;
      createOrder({
        cid: this.tid,
        info: this.info,
        tel: this.tel,
        ticket_type: this.sence.id,
        use_date: this.date
      })
        .then(res => {
          if (res) {
            let orderid = res.orderid;
            that.payOrderByOrderId(orderid);
          } else {
            this.$message.error(res);
            this.loading = false;
          }
        })
        .catch(err => {
          console.log(err);
          this.$message.error("预约失败,请检查网络后重试");
          this.loading = false;
        });
    },
    // 确定预约
    nextStep() {
      this.check()
        .then(res => {
          console.log(res);
          this.loading = true;
          this.createOrderDe();
        })
        .catch(err => {
          this.$message.error(err);
        });
    },
    selectPrice(index) {
      let mes = this.shape.filter(item => item.id == this.info[index].shape);
      this.info[index].price = mes[0].price;
    },
    leftStep() {
      this.$emit("leftStep");
    }
  },
  created() {},
  mounted() {}
};
</script>
<style lang="less" scoped>
.page {
  padding: 10px;
}
.info_header {
  p {
    height: 40px;
    line-height: 40px;
    font-weight: 700;
    font-size: 18px;
    border-bottom: 1px solid #ccc;
  }
}
.info_item {
  margin-bottom: 15px;
}
.add {
  margin: 20px 0;
  text-align: left;
}
/deep/.price {
  text-align: right;
  font-size: 18px;
  .num {
    display: inline-block;
    font-weight: 700;
    color: orange;
  }
}
</style>
